import React from 'react'
import Select from 'react-select';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { isUncoded, isRahBankOrCredit } from './Columns/columnsHelpers';
import { OptionCustomer, OptionAccountR1, OptionAccount, OptionGst } from '../UI/select';
import { customStylesCode400, customStylesCode450 } from '../UI/select-styles';
import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@material-ui/icons/Check';
import Tooltip from '@material-ui/core/Tooltip';

let TransactionCodeForm = props => {
    const { account,
        selectedTransactions,
        transactionCodes,
        classification,
        isR1,
        isRah,
        displayAccount,
        chart,
        contacts,
        handleSubmit,
        AccountCode,
        GstCode,
        contactId,
        classificationId,
        taxTracking,
        change } = props;
    const isMoneyOut = selectedTransactions[0].Amount < 0;
    const contactsOut = [...contacts.filter((item) => (item.isSupplier)),
    ...contacts.filter(item => item.isEmployee),
    ...contacts.filter(item => item.isSuperfund),
    ...contacts.filter(item => item.isOther)];
    const contactsIn = [...(account.isCreditCard ? [...contacts.filter(item => item.isSupplier), ...contacts.filter(item => item.isEmployee)] : []),
    ...contacts.filter(item => item.isCustomer), ...contacts.filter(item => item.isOther)];
    const contactOptions = isMoneyOut ? contactsOut : contactsIn;
    const taxPurchase = transactionCodes.taxCodes.filter((item) => item.isPurchase);
    const taxSale = account.isCreditCard ? taxPurchase : transactionCodes.taxCodes.filter((item) => item.isSales);
    const taxOptions = isMoneyOut ? taxPurchase : taxSale;

    const isAccount = Boolean(AccountCode && AccountCode.length !== 0);

    const tooltipAccount = isAccount ? AccountCode.label : '';
    const tooltipGstCode = GstCode && GstCode.label ? GstCode.label : '';
    const tooltipContactId = contactId && contactId.label ? contactId.label : '';
    const tooltipClassificationId = classificationId && classificationId.label ? classificationId.label : '';
    const isDisabled = isRahBankOrCredit(AccountCode) || (!AccountCode && selectedTransactions.some(item => {
        const accountCode = transactionCodes.chart.find(x => x.value === item.AccountCode);
        return isRahBankOrCredit(accountCode) || isUncoded(item, isRah) || (isRah && item.MatchId);
    }));

    const RenderAccountSelect = ({ input, options, name, id, change }) => (
        <Select
            {...input} isClearable
            id={id}
            name={name}
            value={input.value}
            onChange={(value) => {
                let defaultTaxCode = null;
                if (value)
                    defaultTaxCode = taxOptions.find(item => item.value === value.defaultTaxCode);
                change('GstCode', defaultTaxCode);
                input.onChange(value);
            }}
            onBlur={() => input.onBlur()}
            blurInputOnSelect
            closeMenuOnSelect
            menuPlacement="auto"
            components={isR1 ? { Option: OptionAccountR1 } : { Option: OptionAccount }}
            options={chart.filter(chart => chart.value !== 'split' && chart.value !== 'match' && chart.isActive !== false)}
            formatOptionLabel={option => (!displayAccount || option.value.length === 20) ? option.label : option.value}
            styles={customStylesCode450}
        />)

    const RenderContactSelect = ({ input, options, name, id }) => (
        <Select
            {...input} isClearable
            styles={customStylesCode400}
            id={id}
            name={name}
            options={options.filter(item => item.isActive !== false)}
            value={input.value}
            onChange={value => input.onChange(value)}
            onBlur={() => input.onBlur()}
            isDisabled={isDisabled}
            blurInputOnSelect
            closeMenuOnSelect
            menuPlacement="auto"
            components={{ Option: OptionCustomer }}
        />)

    const RenderGstSelect = ({ input, options, name, id }) => (
        <Select
            {...input} isClearable
            styles={customStylesCode400}
            id={id}
            name={name}
            options={options.filter(item => item.isActive !== false)}
            value={input.value}
            onChange={value => input.onChange(value)}
            onBlur={() => input.onBlur()}
            isDisabled={isDisabled}
            blurInputOnSelect
            closeMenuOnSelect
            menuPlacement="auto"
            components={{ Option: OptionGst }}
        />)

    return (
        <form style={{ display: 'flex', border: 'solid 1px lightgray', margin: 10, paddingLeft: 15, paddingRight: 15, borderRadius: 30 }} onSubmit={handleSubmit}>
            <div style={{ display: 'flex' }} >
                <div style={{ margin: 'auto', marginRight: 15 }}>
                    Account
            </div>
                <Tooltip title={tooltipAccount} placement="top">
                    <div style={{ width: 120, margin: 'auto', marginRight: 10 }}>
                        <Field name="AccountCode" component={RenderAccountSelect} change={change} />
                    </div>
                </Tooltip>
            </div>
            {taxTracking && <div style={{ display: 'flex' }} >
                <div style={{ margin: 'auto', marginRight: 10 }}>
                    Tax code
            </div>
                <Tooltip title={tooltipGstCode} placement="top">
                    <div style={{ width: 120, margin: 'auto', marginRight: 10 }}>
                        <Field name="GstCode" component={RenderGstSelect} options={taxOptions} />
                    </div>
                </Tooltip>
            </div>}
            <div style={{ display: 'flex' }} >
                <div style={{ margin: 'auto', marginRight: 10 }}>
                    Contact
            </div>
                <Tooltip title={tooltipContactId} placement="top">
                    <div style={{ width: 120, margin: 'auto', marginRight: 10 }}>
                        <Field name="contactId" component={RenderContactSelect} options={contactOptions} />
                    </div>
                </Tooltip>
            </div>
            <div style={{ display: 'flex' }} >
                <div style={{ margin: 'auto', marginRight: 10 }}>
                    Classification
            </div>
                <Tooltip title={tooltipClassificationId} placement="top">
                    <div style={{ width: 120, margin: 'auto', marginRight: 10 }}>
                        <Field name="classificationId" component={RenderContactSelect} options={classification} />
                    </div>
                </Tooltip>
            </div>
            <div style={{ margin: 'auto' }}>
                <IconButton aria-label="code" type="submit" >
                    <CheckIcon />
                </IconButton>
            </div>
        </form>
    )
}

TransactionCodeForm = reduxForm({
    form: 'transactionCodeForm'
})(TransactionCodeForm)

const selector = formValueSelector('transactionCodeForm');

TransactionCodeForm = connect(state => {
    const { AccountCode, GstCode, contactId, classificationId } = selector(state, 'AccountCode', 'GstCode', 'contactId', 'classificationId');
    return { AccountCode, GstCode, contactId, classificationId };
})(TransactionCodeForm);

export default TransactionCodeForm;


// WEBPACK FOOTER //
// ./src/components/TransactionList/TransactionCodeForm.js